export default __webpack_public_path__ + "static/media/ksm.5a5e51f6.svg";